import { DeviceDetectorService } from "../../../ServiceDesk/sdServices/device-detector-service";
import { CustomKeyValues } from "../../logger/telemetry-service";

export class ActionTriggerBinding {
  /** The glyph icon to display to the left of the trigger. */
  public icon = "@?";

  /** Text to display on the action trigger. */
  public text = "@";

  /** true/false Set to true to remove text and only display glyph icon. */
  public glyphOnly = "<?";

  /** fn to execute on action trigger click. This function takes no parameters. */
  public onClick = "&";

  /** Determines if the control needs to be disabled. */
  public isDisabled = "<?";

  /** The business intelligence (BI) behavior for this component. Valid values are the enumeration names found in ServiceDesk.Services.PageActionBehavior enumeraiton.*/
  public biBehavior = "@?";

  /** The identifier for all business intelligence (BI) actions triggered by this component. */
  public biId = "@?";

  /** The accessibility label for this button, the value defaults to the content if not provided */
  public ariaLabel = "@?";

  /** The ARIA role for this component. Default is 'button', can be set to 'link' for link-like functionality */
  public role = "@?";

  public title = "@";

  public telemetryData = "<?";

  public scenario = "<?";

  public scenarioStep = "<?";

  public ariaDescribedby = "@?";
}

/** Controller for ActionTrigger component. */
export class ActionTriggerController {
  public icon: string;
  public text: string;
  public glyphOnly: boolean;
  public showText = true;
  public glyphClass = "";
  public title: string;
  public htmlTitle: string = undefined;
  public onClick: () => void;
  public biId: string;
  public isDisabled: boolean;
  public role: string;
  public telemetryData: CustomKeyValues;
  public scenario: string;
  public scenarioStep: string;
  public deviceDetector: DeviceDetectorService;
  // @ngInject
  constructor(
    private $log: ng.ILogService,
    private $scope: ng.IScope,
    private $element: ng.IAugmentedJQuery,
    private $attrs: ng.IAttributes
  ) {
    this.$scope.$watch(
      () => this.$element.attr("disabled"),
      () => {
        if ((<any>this.$attrs?.$attr)?.actionEligibility) this.isDisabled = !!this.$element.attr("disabled");
      }
    );
  }

  /** Component lifecycle events */
  public $onInit(): void {
    this.refreshView();
  }

  public $onChanges(changesObj: any): void {
    this.refreshView();
  }

  /** Gets executed when the action link is clicked */
  public onSelected($event?: ng.IAngularEvent) {
    // Commented below code against bug https://microsoft.visualstudio.com/OSGS/_workitems/edit/32556840
    //if ($event) {
    //    $event.preventDefault();
    //}

    if (angular.isFunction(this.onClick)) {
      this.onClick();
    }
  }

  private refreshView(): void {
    if (this.glyphOnly && this.glyphOnly === true) {
      this.showText = false;

      if (!this.icon || this.icon === "") {
        this.$log.error("ArgumentException: when the action-trigger is glyph only, icon class must be provided.");
      }
    }

    if (this.icon && this.icon !== "") {
      this.glyphClass = `c-glyph ${this.icon}`;
    }

    this.htmlTitle =
      this.deviceDetector && this.deviceDetector.browser !== "chrome" && !this.showText ? this.text : undefined;
  }
}

export const sdActionTriggerComponent: ng.IComponentOptions = {
  bindings: <any>new ActionTriggerBinding(),
  controller: ActionTriggerController,
  templateUrl: "../ShellCommon/Controls/actionTrigger/actionTrigger.html"
};
